import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { NgSelectModule } from '@ng-select/ng-select';
import { Angulartics2Module } from 'angulartics2';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import {
  FormValidationModule,
  ChatCounterModule,
  ReplaceSmartPunctuationModule,
} from '@tablesready/common-ui';
import { WaitlistOptionsComponent } from './waitlist-options.component';
import { QuotedTimeModal } from './components/quoted-time-modal/quoted-time-modal.component';
import { WaitlistOptionsRoutingModule } from './waitlist-options.routing.module';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { AuthModule } from '@tablesready/frontend-auth';
import { AlertsModule } from '@tablesready/frontend-alerts-bar';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';

@NgModule({
  declarations: [
    WaitlistOptionsComponent,
    QuotedTimeModal,
  ],
  imports: [
    FrontendIconsModule,
    CommonModule,
    ReactiveFormsModule,
    AuthModule,
    AlertsModule,
    FormValidationModule,
    ChatCounterModule,
    ReplaceSmartPunctuationModule,
    NgSelectModule,
    Angulartics2Module,
    NgbModule,
    WaitlistOptionsRoutingModule,
    FrontendDropdownModule,
    FrontendPullRefreshModule,
  ],
  exports: [
    WaitlistOptionsComponent,
  ],
})
export class WaitlistOptionsModule {}
